<template>
  <div id="app">
    <div class="navigationBar">
      <router-link class="navigationHeader" to="/">HIGHGROUND</router-link>
      <div style="flex-grow: 1"></div>
      <div class="navigationTo">  
        <router-link class="navigationRouterLink" to="/">Home</router-link>
        <router-link class="navigationRouterLink" to="/About">About</router-link>
        <router-link class="navigationRouterLink" to="/Discover">Discover</router-link>
        <a class="navigationRouterLink" href="mailto:info@evntl.com" target="_blank">Contact</a>
        <div class="navigationRouterLogo" @click="toggle = !toggle"><img :src="menu" alt="menu"></div>
      </div>
    </div>
    <transition name='slide-fade'>
      <div class="menuDropdown" v-if="toggle">
        <ul>
          <li @click="toHome">Home</li>
          <li @click="toAbout">About</li>
          <li @click="toDiscover">Discover</li>
        </ul>
      </div>
    </transition>
    <router-view />
  </div>
</template>
<script>
import menuLogo from '@/assets/menuIcon.svg';

  export default {
    name: 'App',
    data() {
      return {
        toggle: false,
        contact: false,
        subject: '',
        message: '',
        from: '',
        menu: menuLogo
      }
    },
    methods: {
      toHome() {
        this.$router.push('/');
        this.toggle = false;
      },
      toAbout() {
        this.$router.push('/About');
        this.toggle = false;
      },
      toDiscover() {
        this.$router.push('/Discover');
        this.toggle = false;
      }
    },
  }
</script>

<style>
#app {
  font-family: "Lato", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to{
  transform: translateY(-1rem);
  opacity: 0;
}

@media (max-width: 900px) {
  .navigationBar {
    background-color: #1E1E1E;
    padding: 1rem 0;
    position: fixed;
    display: table;
    width: 100%;
    box-shadow: 0px 3px 0.3rem rgb(90, 90, 90);
    z-index: 1100;
    transition: all 1s ease-in-out;
  }
  .menuDropdown {
    background-color: white;
    color: #1e1e1e;
    position: fixed;
    top: 75px;
    z-index: 1099;
    width: 100%;
    box-shadow: 0 0.1rem 0.1rem #ccc;
  }
  .menuDropdown li{
    list-style-type: none;
    margin: 1.5rem 0;
    font-size: 2.5vw;
    font-weight: bold;
  }
  .navigationBar .navigationHeader {
    color: white;
    text-decoration: none;
    padding-left: 2rem;
    display: table-cell;
    vertical-align: middle;
  }

  .navigationBar .navigationTo {
    color: white !important;
    display: inline-flex;
    padding-right: 2rem;
    float: right;
  }

  .navigationBar .navigationTo .navigationRouterLink {
    display: none;
  }

  .navigationBar .navigationTo .navigationRouterLogo > img {
    height: auto;
    width: 100%;
    cursor: pointer;
  }

  .navigationBar .navigationTo .navigationRouterLink.router-link-exact-active {
    font-weight: bold;
  }
}
@media (min-width: 900px) {
  .navigationBar {
    background-color: #1E1E1E;
    padding: 1.5rem 0;
    position: fixed;
    display: flex;
    top: 1rem;
    left: 2rem;
    width: 100%;
    box-shadow: 4px 3px 0.3rem rgb(90, 90, 90);
    z-index: 1100;
    transition: all 1s ease-in-out;
  }

  .navigationBar .navigationHeader {
    color: white;
    text-decoration: none;
    padding-left: 2rem;
  }

  .navigationBar .navigationTo {
    color: white !important;
    display: inline-flex;
    padding-right: 2rem;
  }

  .navigationBar .navigationTo .navigationRouterLink {
    margin-right: 2rem;
    text-decoration: none;
    color: white;
  }

  .navigationBar .navigationTo .navigationRouterLogo {
    margin-right: 4rem;
    display: none;
  }
  .navigationBar .navigationTo .navigationRouterLink.router-link-exact-active {
    font-weight: bold;
  }
}
</style>
